import React, {FC, Fragment} from 'react';
import GalleryView from 'components/gallery-view';
import {ProjectIndex} from 'types/project';

const ProjectCover: FC<{project: ProjectIndex}> = props => {
  const {project} = props;

  return (
    <Fragment>
      {project.project_image ? (
        <GalleryView
          images={[project.project_image]}
          previewSize={36}
          size="small"
        />
      ) : null}
    </Fragment>
  );
};

export default ProjectCover;
